import type { ReactNode, Ref } from 'react';
import { Link } from 'react-router';

/**
 * The one header a post or a reel is made under: where you are on the left, the steps in the
 * middle, a way to start over and the Drafts link on the right. The steps are either passed in
 * (`rail`) or portalled into `railRef` by whoever owns them (the post wizard).
 */
export function FlowHeader({
  place,
  title,
  rail,
  railRef,
  newLabel,
  onNew,
  newDisabled = false,
  saved,
  note,
}: {
  place: string;
  title: string;
  rail?: ReactNode;
  railRef?: Ref<HTMLDivElement>;
  newLabel: string;
  /** Shown only once something is saved: before that there is nothing to start over from. */
  onNew?: () => void;
  newDisabled?: boolean;
  saved: boolean;
  /** A short line of context, e.g. the day picked on the calendar. */
  note?: string | null;
}) {
  return (
    <header className="nx-flow-head">
      <div className="nx-flow-inner">
        <span className="nx-flow-title">
          {place} · {title}
        </span>
        <div className="nx-flow-rail" ref={railRef}>
          {rail}
        </div>
        <div className="nx-flow-links">
          {note && <span className="nx-flow-note">{note}</span>}
          {saved && onNew && (
            <button type="button" className="nx-quiet" onClick={onNew} disabled={newDisabled}>
              {newLabel}
            </button>
          )}
          <Link to="/app/posts" state={{ tab: 'Drafts' }} className="nx-quiet">
            {saved ? 'Saved in Drafts' : 'Drafts'}
          </Link>
        </div>
      </div>
    </header>
  );
}
